import { put, takeEvery } from "redux-saga/effects"
import {
  addBasicContentFailed,
  addBasicContentSuccess,
  getBasicContentFailed,
  getBasicContentListFailed,
  getBasicContentListSuccess,
  getBasicContentSuccess,
  updateBasicContentFailed,
  updateBasicContentSuccess,
} from "./actions"
import { axiosPut, get, post } from "helpers/api_helper"
import {
  ADD_BASIC_CONTENT,
  GET_BASIC_CONTENT,
  GET_BASIC_CONTENT_LIST,
  UPDATE_BASIC_CONTENT,
} from "./actionTypes"
import {
  showSavingModal,
  hideSavingModal,
  putMenuItemSuccess,
  setIsOutdated,
  setSelectedFeature,
} from "../actions"
import { getFormDataFromJSON } from "utils"

function* addBasicContent({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post("/basic-content", getFormDataFromJSON(params))
    yield put(addBasicContentSuccess(response))
    const menuItem = yield axiosPut("/admin/menu-item", {
      entity_id: response.id,
      menu_item_id: response.menu_item_id,
    })
    yield put(putMenuItemSuccess(menuItem))
    yield put(setSelectedFeature(menuItem))
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addBasicContentFailed(error))
  }
}

function* getBasicContent({ payload: params }) {
  try {
    const response = yield get(`/basic-content/${params}`)
    yield put(getBasicContentSuccess(response))
  } catch (error) {
    yield put(getBasicContentFailed(error))
  }
}

function* updateBasicContent({ payload: { params, id } }) {
  try {
    yield put(showSavingModal())
    const response = yield post(
      `/basic-content/${id}`,
      getFormDataFromJSON(params)
    )
    yield put(updateBasicContentSuccess(response))
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateBasicContentFailed(error))
  }
}

function* getBasicContentList({ payload: params }) {
  try {
    const response = yield get("/basic-content", { params })
    yield put(getBasicContentListSuccess(response))
  } catch (error) {
    yield put(getBasicContentListFailed(error))
  }
}

function* basicContentSaga() {
  yield takeEvery(ADD_BASIC_CONTENT, addBasicContent)
  yield takeEvery(GET_BASIC_CONTENT, getBasicContent)
  yield takeEvery(UPDATE_BASIC_CONTENT, updateBasicContent)
  yield takeEvery(GET_BASIC_CONTENT_LIST, getBasicContentList)
}

export default basicContentSaga
